import {RouteRecordRaw} from "vue-router";
import NotFound from "@/views/status/NotFound.vue";
import HeaderLogoView from "@/views/share/HeaderLogoView.vue";

export default <Array<RouteRecordRaw>>[
    {
        path: '/status/404',
        name: 'notfound',
        meta: {auth: false},
        components: {
            default: NotFound,
            header: HeaderLogoView
        }
    },
]
